const roomData = {
  bathroom: {
    name: 'Bathroom / WC',
    elec_watt: 118.5,
    gas_watt: 119.3,
    r_watt: 139.3,
  },
  kitchen: {
    name: 'Kitchen / Utility',
    elec_watt: 52.9,
    gas_watt: 53.2,
    r_watt: 72.7,
  },
  bedroom: {
    name: 'Bedroom',
    elec_watt: 50.0,
    gas_watt: 51.2,
    r_watt: 75.3,
  },
  livingroom: {
    name: 'Living Room / Dining Room',
      elec_watt: 55.7,
      gas_watt: 55.9,
      r_watt: 79.2,
    },
  conservatory: {
    name: 'Conservatory / Porch',
      elec_watt: 0,
      gas_watt: 0,
      r_watt: 0,
    },
  hallway: {
    name: 'Hallway / Landing',
      elec_watt: 46.8,
      gas_watt: 47.0,
      r_watt: 0,
    },
};

export default roomData;
